import React from "react";
import world from "../../image/globe.png";
import { Link } from "react-router-dom";

import "./header.css";
const Header = () => {
  return (
    <div>
      <header id="home">
        <div className="icon">
          <img src={world} alt="world" width={40} height={40} />
          <h4>
            <a style={{ textDecoration: "none", color: "black" }} href="/#home">
              RestAroundYou.com
            </a>
          </h4>
        </div>
        <div className="buttons">
          <Link to="/activity"> Create an activity</Link>
        </div>
        <div className="style-page">
          <h3>Thanks for visit this page </h3>
        </div>
      </header>
    </div>
  );
};

export default Header;
